module.exports = __webpack_public_path__ + "img/fees.daily.4028ae99.png";